import React, { Component } from "react"
import { Switch } from "antd"
export default class SwitchS extends Component {
  render() {
    const { ...rest } = this.props

    return (
      <Switch
        checkedChildren="开启"
        unCheckedChildren="停用"
        {...rest}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/FormComponents/index.js